export default __webpack_public_path__ + "static/media/placeholder_store01-fr-web.66993d61.png";